import { updateClassState } from 'store/reducer.helpers';
import { User } from 'store/user/types';
import { ISignInResDto, TwoFAEnforcementDto } from 'store/user/types/api-bodies.types';
import { Service } from 'store/user/types/service';
import { IRegion } from 'store/user/types/state.types';

export function setTokenReducer(state: User, payload: ISignInResDto) {
  const user = updateClassState(state, state);
  user.token = payload.data.accessToken;
  user.tokenExpiresAt = payload.data.expiresAt;
  return user;
}

export function setLoading(state: User, payload: boolean) {
  const user = updateClassState(state, state);
  user.loading = payload;
  return user;
}

export function clearUserReducer() {
  const user = new User();
  user.loading = false;
  return user;
}

export function setRegionHelper(state: User, payload: IRegion) {
  const user = updateClassState(state, state);
  user.region = payload;
  return user;
}
export function setRegionsHelper(state: User, payload: IRegion[]) {
  const user = updateClassState(state, state);
  user.regions = payload;
  return user;
}

export function setServicesHelper(state: User, payload: Service[]) {
  const user = updateClassState(state, state);
  user.services = payload;
  return user;
}

export function setTwoFAEnforcement(state: User, payload: TwoFAEnforcementDto) {
  const user = updateClassState(state, state);
  user.twoFaEnforcement = payload;
  return user;
}

export function setLanguage(state: User, payload: string) {
  const user = updateClassState(state, state);
  user.language = payload;
  return user;
}
